import React from 'react';
import './style.sass';
import FullWrapper from '../../cases/reusable-components/layouts-components__common-cases/full-wrapper';
const BlocksWithIcons = ({ params, caseName = '' }) => {
    return (
        <FullWrapper caseName={`${caseName}`}>
            {params.title && <div className="case-icon-blocks"></div>}
            <div className="case-icon-blocks__statistic">
                {params.blocks.map(item => (
                    <div className="case-icon-blocks__item" key={item}>
                        <div className="case-icon-blocks__top">
                            <div className="case-icon-blocks__text">{item.title}</div>
                            <img src={item.icon} alt="metrics" className="case-icon-blocks__icon" />
                        </div>
                        <div>
                            <span
                                className="case-icon-blocks__text-s"
                                dangerouslySetInnerHTML={{ __html: item.before }}
                            />
                            <span
                                className="case-icon-blocks__number"
                                dangerouslySetInnerHTML={{ __html: item.number }}
                            />
                            <span
                                className="case-icon-blocks__text-s"
                                dangerouslySetInnerHTML={{ __html: item.after }}
                            />
                        </div>
                    </div>
                ))}
            </div>
        </FullWrapper>
    );
};

export default BlocksWithIcons;
